export default __webpack_public_path__ + "static/media/49.6cae0f08.png";